import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BaseGridList from '@mui/material/ImageList';
import BaseGridListTile from '@mui/material/ImageListItem';
import BaseImageList from '@mui/material/ImageList';
import BaseImageListItem from '@mui/material/ImageListItem';
import researchSlideShape from 'shapes/researchSlideShape';
import { autoOptimizeImage } from 'utils/functions';

const ImageListWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  overflow: hidden;
`;

const ImageList = styled(BaseImageList)`
  flex-wrap: nowrap;
`;

// using important here to override inline height added by material-ui
const ImageListItem = styled(BaseImageListItem)`
  height: 100% !important;

  .MuiGridListTile-tile {
    height: inherit;

    img {
      height: 100%;
      width: 100%;
    }
  }
`;

SwipeableCarousel.propTypes = {
  carouselHeight: PropTypes.number,
  imageRef: PropTypes.object,
  slideDecks: PropTypes.arrayOf(researchSlideShape),
  totalImages: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
  }))
};

function SwipeableCarousel({
  carouselHeight,
  imageRef,
  slideDecks,
  totalImages
}) {
  return (
    <ImageListWrapper>
      {slideDecks.map((slideDeck, deckIndex) => (
        <ImageList key={`slideDeck-${deckIndex}`} cols={1}>
          {totalImages.map((slideImage, slideIndex) => (
            <ImageListItem
              $height={carouselHeight}
              key={`slide-image-${slideIndex}`}
              ref={imageRef}
            >
              <img alt={`slide ${slideImage.title}`} src={autoOptimizeImage(slideImage.url)} />
            </ImageListItem>
          ))}
        </ImageList>
      ))}
    </ImageListWrapper>
  );
}

export default SwipeableCarousel;
